'use client';

import { usePathname } from '@/i18n/routing';
import Script from 'next/script';
import { useEffect } from 'react';

export function MatomoCounter({ siteId }: { siteId: number | null }) {
  const pathname = usePathname();

  useEffect(() => {
    const _paq = ((window as any)._paq = (window as any)._paq || []);

    if (!_paq._initialized) {
      // первый визит
      _paq.push(['trackPageView']);
      _paq.push(['enableLinkTracking']);
      _paq.push(['setTrackerUrl', '//matomo.dgov-uic.uz/matomo.php']);
      _paq.push(['setSiteId', siteId]);

      const d = document;
      const g = d.createElement('script');
      const s = d.getElementsByTagName('script')[0];
      g.async = true;
      g.src = '//matomo.dgov-uic.uz/matomo.js';
      s.parentNode?.insertBefore(g, s);

      _paq._initialized = true;
    } else {
      // SPA навигация
      _paq.push(['setCustomUrl', window.location.pathname + window.location.search]);
      _paq.push(['trackPageView']);
    }
  }, [pathname, siteId]);

  return <Script id="matomo-tracker" strategy="afterInteractive" />;
}
